import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../realize_overrides/components/modal/modal.jsx';

import { ModalActions, ModalStore } from '../../../realize_overrides/stores/modal_store';

import mixin from 'react-mixin';

const Realize = {
	i18n: window.Realize.i18n,
	Modal: Modal,
	ModalHeader: window.ModalHeader,
	ModalContent: window.ModalContent,
	ModalFooter: window.ModalFooter
};

@mixin.decorate(Reflux.listenTo(ModalStore, "onModalAction"))
export default class LabelHelpTextModal extends React.Component {
	static propTypes = {
		modalId: PropTypes.string,
		description: PropTypes.string,
		helpText: PropTypes.string,
		isMobile: PropTypes.bool
	};

	static defaultProps = {
		description: '-',
		isMobile: false
	};

	constructor(props) {
		super(props);
		this.state = {
			description: '-'
		}
	}

	onModalAction(props) {
		if(this.props.modalId === props.modalId) {
			this.setState({description: props.description});
		}
	}

	getDescription() {
		return this.state.description;
	};

	dismissModal() {
		ModalActions.close({ modalId: this.props.modalId });
	}

	renderDismissButton() {
		return (
			<Button
			name={Realize.i18n.t('actions.close')}
			element="a"
			icon="close"
			style="cancel"
			role= 'button'
			onClick={this.dismissModal.bind(this)}
			/>
		);
	}

	focusAutoComplete(modalId){
		if($(`#${modalId}`).is(':visible') === true){
			let btnClose = $('#help-text-modal .modal-footer .button-cancel');
			btnClose.attr('tabIndex', 0);

			btnClose.unbind('keydown').keydown((e) => {
				if(e.keyCode === 9){
					$(".h5-custom").focus();
					return false;
				}

				if(e.which === 13)
					btnClose[0].click();
			});
		}
	}

	render() {
		setTimeout(() => { this.focusAutoComplete(this.props.modalId)}, 600);
		return (
			<Realize.Modal id={this.props.modalId} ready={this.ready} isMobile={this.props.isMobile} style={{zIndex: '99999'}}>
				<Realize.ModalHeader>
					<span className="h5-custom" tabIndex="0" id={`${this.props.modalId}_title`}>
						{Realize.i18n.t('process.helpText')}
					</span>
				</Realize.ModalHeader>
				<Realize.ModalContent>
					<div className="process-help-modal__item" tabIndex="0">
					<p>{this.getDescription()}</p>
					</div>
				</Realize.ModalContent>
				<Realize.ModalFooter className={'right-align'}>
					{this.renderDismissButton()}
				</Realize.ModalFooter>
			</Realize.Modal>
		);
	}
}
